(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["morivia-about-founder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      var els = (root || document).querySelectorAll('[data-morivia-reveal]:not([data-reveal])');
      if (!els.length) return;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || !('IntersectionObserver' in window)) {
        els.forEach(function (el) { el.setAttribute('data-reveal', 'done'); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.setAttribute('data-reveal', 'done');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.25 });
      els.forEach(function (el) {
        el.setAttribute('data-reveal', 'pending');
        io.observe(el);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["morivia-about-story"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      var els = (root || document).querySelectorAll('[data-morivia-reveal]:not([data-reveal])');
      if (!els.length) return;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || !('IntersectionObserver' in window)) {
        els.forEach(function (el) { el.setAttribute('data-reveal', 'done'); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.setAttribute('data-reveal', 'done');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.25 });
      els.forEach(function (el) {
        el.setAttribute('data-reveal', 'pending');
        io.observe(el);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["morivia-contact-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SELECTOR = '.morivia-contact__form';
    var SUCCESS_ICON =
      '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>';
    var ERROR_ICON =
      '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>';

    function showMessage(status, type, text) {
      var wrap = document.createElement('div');
      wrap.className = 'morivia-contact__message morivia-contact__message--' + type;
      wrap.tabIndex = -1;
      wrap.innerHTML = (type === 'success' ? SUCCESS_ICON : ERROR_ICON) + '<span></span>';
      wrap.querySelector('span').textContent = text;
      status.innerHTML = '';
      status.appendChild(wrap);
      wrap.focus({ preventScroll: true });
      if (wrap.scrollIntoView) wrap.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      return wrap;
    }

    function clearMessage(status) {
      var msg = status.firstElementChild;
      if (!msg) return;
      msg.classList.add('is-leaving');
      setTimeout(function () {
        if (msg.parentNode === status) status.innerHTML = '';
      }, 300);
    }

    function setLoading(button, loading) {
      button.classList.toggle('is-loading', loading);
      button.disabled = loading;
      button.setAttribute('aria-busy', loading ? 'true' : 'false');
    }

    function init(form) {
      if (form.dataset.moriviaAjax === 'true') return;
      form.dataset.moriviaAjax = 'true';

      var status = form.querySelector('[data-contact-status]');
      var button = form.querySelector('[data-contact-submit]');
      var emailInput = form.querySelector('input[type="email"]');
      var hideTimer;

      // Seconds before the success message hides (set in the theme customizer). 0 = never hide.
      var hideDelay = (parseInt(status.getAttribute('data-hide-delay'), 10) || 0) * 1000;

      function scheduleHide() {
        clearTimeout(hideTimer);
        if (hideDelay > 0) {
          hideTimer = setTimeout(function () { clearMessage(status); }, hideDelay);
        }
      }

      // Page re-rendered by the server with a success message (no-JS or captcha fallback).
      if (status.querySelector('.morivia-contact__message--success')) scheduleHide();

      // Remove the red error border as soon as the person edits the email.
      if (emailInput) {
        emailInput.addEventListener('input', function () {
          emailInput.classList.remove('morivia-contact__input--error');
          emailInput.removeAttribute('aria-invalid');
        });
      }

      form.addEventListener('submit', function (event) {
        if (!window.fetch || !window.FormData || !window.DOMParser) return; // normal submit fallback

        if (!form.checkValidity()) {
          event.preventDefault();
          form.reportValidity();
          return;
        }

        event.preventDefault();
        clearTimeout(hideTimer);
        setLoading(button, true);

        fetch(form.action, {
          method: 'POST',
          body: new FormData(form),
          headers: { Accept: 'text/html' },
          credentials: 'same-origin'
        })
          .then(function (response) {
            // Shopify bot protection redirects to a challenge page: let the browser handle it.
            if (response.redirected && /\/challenge/.test(response.url)) {
              form.submit();
              return null;
            }
            return response.text();
          })
          .then(function (html) {
            if (html === null) return;

            var doc = new DOMParser().parseFromString(html, 'text/html');
            var serverForm = doc.getElementById(form.id);
            var successEl = serverForm && serverForm.querySelector('.morivia-contact__message--success span');
            var errorEl = serverForm && serverForm.querySelector('.morivia-contact__message--error span');

            if (successEl) {
              showMessage(status, 'success', successEl.textContent.trim());
              form.reset();
              if (emailInput) {
                emailInput.classList.remove('morivia-contact__input--error');
                emailInput.removeAttribute('aria-invalid');
              }
              scheduleHide();
            } else if (errorEl) {
              clearTimeout(hideTimer);
              showMessage(status, 'error', errorEl.textContent.trim());
              if (emailInput) {
                emailInput.classList.add('morivia-contact__input--error');
                emailInput.setAttribute('aria-invalid', 'true');
                emailInput.focus({ preventScroll: true });
              }
            } else {
              // Unknown response (e.g. a captcha page): fall back to a regular submit.
              form.submit();
            }
          })
          .catch(function () {
            form.submit(); // network problem: let the browser try normally
          })
          .then(function () {
            setLoading(button, false);
          });
      });
    }

    function initAll(root) {
      (root || document).querySelectorAll(SELECTOR).forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    // Re-initialise inside the Shopify theme editor when a section is added or reloaded.
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["morivia-pdp-pairing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SWIPER_SRC = 'https://cdn.jsdelivr.net/npm/swiper@11.1.14/swiper-bundle.min.js';

    function whenReady(fn) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', fn, { once: true });
      } else {
        fn();
      }
    }

    function loadSwiper() {
      if (window.Swiper) return Promise.resolve(window.Swiper);
      if (window.__moriviaSwiperPromise) return window.__moriviaSwiperPromise;
      window.__moriviaSwiperPromise = new Promise(function (resolve, reject) {
        var script = document.createElement('script');
        script.src = SWIPER_SRC;
        script.async = true;
        script.onload = function () { resolve(window.Swiper); };
        script.onerror = function () { window.__moriviaSwiperPromise = null; reject(new Error('Swiper failed to load')); };
        document.head.appendChild(script);
      });
      return window.__moriviaSwiperPromise;
    }

    function pad(n) { return n < 10 ? '0' + n : String(n); }

    if (!customElements.get('morivia-pair-slider')) {
      customElements.define('morivia-pair-slider', class extends HTMLElement {
        connectedCallback() {
          whenReady(this.setup.bind(this));
        }

        disconnectedCallback() {
          if (this.swiper) {
            this.swiper.destroy(true, true);
            this.swiper = null;
          }
        }

        setup() {
          if (this.swiper || !this.isConnected) return;
          this.root = this.querySelector('.swiper');
          if (!this.root) return;
          this.prevBtn = this.querySelector('[data-pair-prev]');
          this.nextBtn = this.querySelector('[data-pair-next]');
          this.progress = this.querySelector('[data-pair-progress]');
          this.counter = this.querySelector('[data-pair-counter]');
          this.total = this.root.querySelectorAll('.swiper-slide').length;
          this.updateUI(0);

          if (this.total < 2) return;

          loadSwiper().then(function (Swiper) {
            if (!this.isConnected || this.swiper) return;
            this.swiper = new Swiper(this.root, {
              slidesPerView: 1,
              spaceBetween: 16,
              speed: 650,
              grabCursor: true,
              watchOverflow: true,
              observer: true,
              observeParents: true,
              keyboard: { enabled: true },
              a11y: { enabled: true },
              on: {
                slideChange: function (s) { this.updateUI(s.activeIndex); }.bind(this)
              }
            });
            if (this.prevBtn) this.prevBtn.addEventListener('click', function () { this.swiper.slidePrev(); }.bind(this));
            if (this.nextBtn) this.nextBtn.addEventListener('click', function () { this.swiper.slideNext(); }.bind(this));
            this.updateUI(this.swiper.activeIndex);
          }.bind(this)).catch(function () {
            // Swiper blocked: the slider still works as a native swipe / scroll-snap row.
            var controls = this.querySelector('.morivia-pairing__controls');
            if (controls) controls.hidden = true;
          }.bind(this));

          // Theme editor: jump to the selected block's slide.
          this.addEventListener('shopify:block:select', function (event) {
            var slide = event.target.closest('.swiper-slide');
            if (!slide || !this.swiper) return;
            var index = Array.prototype.indexOf.call(this.root.querySelectorAll('.swiper-slide'), slide);
            if (index > -1) this.swiper.slideTo(index);
          }.bind(this));
        }

        updateUI(index) {
          if (this.progress && this.total) this.progress.style.width = ((index + 1) / this.total * 100) + '%';
          if (this.counter) this.counter.textContent = pad(index + 1) + ' / ' + pad(this.total);
          if (this.prevBtn) this.prevBtn.disabled = index <= 0;
          if (this.nextBtn) this.nextBtn.disabled = index >= this.total - 1;
        }
      });
    }

    /*
      One click, two products.
      The visible button is the theme's own add-to-cart button for product 1.
      After the theme has added it, the hidden theme button of product 2 is clicked,
      so the cart icon / drawer / animations all behave exactly like a normal add.
    */
    if (!customElements.get('morivia-pair-add')) {
      customElements.define('morivia-pair-add', class extends HTMLElement {
        connectedCallback() {
          whenReady(this.setup.bind(this));
        }

        disconnectedCallback() {
          if (this.primary) this.primary.removeEventListener('click', this.onClick);
        }

        setup() {
          this.primary = this.querySelector('[data-pair-primary] button[name="add"]');
          this.secondary = this.querySelector('[data-pair-secondary] button[name="add"]');
          if (!this.primary || !this.secondary) return;
          this.secondary.setAttribute('tabindex', '-1');
          this.onClick = this.handleClick.bind(this);
          this.primary.addEventListener('click', this.onClick);
        }

        handleClick() {
          if (this.busy) return;
          this.busy = true;
          this.setAttribute('data-busy', '');

          var finished = false;
          var timer;
          var proceed = function () {
            if (finished) return;
            finished = true;
            clearTimeout(timer);
            document.removeEventListener('cart:update', proceed);
            setTimeout(function () {
              this.secondary.click();
              setTimeout(function () {
                this.busy = false;
                this.removeAttribute('data-busy');
              }.bind(this), 1200);
            }.bind(this), 150);
          }.bind(this);

          document.addEventListener('cart:update', proceed);
          timer = setTimeout(proceed, 2500);
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["morivia-pdp-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initReveal(root) {
      var els = (root || document).querySelectorAll('[data-morivia-reveal]:not([data-reveal])');
      if (!els.length) return;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || !('IntersectionObserver' in window)) {
        els.forEach(function (el) { el.setAttribute('data-reveal', 'done'); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.setAttribute('data-reveal', 'done');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.25 });
      els.forEach(function (el) {
        el.setAttribute('data-reveal', 'pending');
        io.observe(el);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initReveal(); });
    } else {
      initReveal();
    }
    document.addEventListener('shopify:section:load', function (event) { initReveal(event.target); });

    function openDialog(dialog) {
      if (!dialog) return;
      if (typeof dialog.showModal === 'function') {
        if (!dialog.open) dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
      var first = dialog.querySelector('input, textarea');
      if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 50);
    }

    function closeDialog(dialog) {
      if (!dialog) return;
      if (typeof dialog.close === 'function') {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
    }

    function resetDialog(dialog) {
      var wrap = dialog.querySelector('.morivia-review-dialog__form-wrap');
      var done = dialog.querySelector('.morivia-review-dialog__success');
      var err = dialog.querySelector('.morivia-review-form__error');
      var btn = dialog.querySelector('.morivia-review-form [type="submit"]');
      if (wrap) wrap.hidden = false;
      if (done) done.hidden = true;
      if (err) err.hidden = true;
      if (btn) btn.disabled = false;
    }

    if (!window.__moriviaReviewTrigger) {
      window.__moriviaReviewTrigger = true;

      document.addEventListener('click', function (event) {
        /* close buttons + click on the dimmed backdrop */
        var closer = event.target.closest('[data-morivia-review-close]');
        if (closer) {
          closeDialog(closer.closest('dialog'));
          return;
        }
        if (event.target.classList && event.target.classList.contains('morivia-review-dialog')) {
          closeDialog(event.target);
          return;
        }

        var link = event.target.closest('[data-morivia-review-trigger], [data-morivia-review-popup]');
        if (!link) return;

        /* 1) a review app button exists on the page -> click it (original behaviour) */
        var selector = link.getAttribute('data-morivia-review-trigger');
        var target = null;
        if (selector) {
          try { target = document.querySelector(selector); } catch (e) { target = null; }
        }
        if (target) {
          event.preventDefault();
          if (target.scrollIntoView) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
          target.click();
          return;
        }

        /* 2) no app and no link -> open the built-in review popup */
        var popupId = link.getAttribute('data-morivia-review-popup');
        if (popupId) {
          event.preventDefault();
          openDialog(document.getElementById(popupId));
        }
      });

      /* reset the popup each time it is closed (Esc, X or backdrop) */
      document.addEventListener('close', function (event) {
        if (event.target.classList && event.target.classList.contains('morivia-review-dialog')) {
          resetDialog(event.target);
        }
      }, true);

      /* submit the review through Shopify's contact form, without leaving the page */
      document.addEventListener('submit', function (event) {
        var form = event.target;
        if (!form.classList || !form.classList.contains('morivia-review-form')) return;
        event.preventDefault();

        var dialog = form.closest('dialog');
        var btn = form.querySelector('[type="submit"]');
        var data = new FormData(form);
        if (btn) btn.disabled = true;

        /* optional: also send the review as JSON to your own endpoint (e.g. to update the metafields) */
        var endpointEl = form.querySelector('[data-morivia-endpoint]');
        var endpoint = endpointEl ? endpointEl.value : '';
        if (endpoint) {
          var payload = {};
          data.forEach(function (value, key) {
            var m = key.match(/^contact\[(.+)\]$/);
            if (m) payload[m[1]] = value;
          });
          try {
            fetch(endpoint, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(payload),
              keepalive: true
            }).catch(function () {});
          } catch (e) {}
        }

        function nativeSubmit() {
          /* normal browser submit: Shopify handles it and returns to this page with ?contact_posted=true */
          form.submit();
        }

        fetch(form.getAttribute('action') || '/contact', {
          method: 'POST',
          body: data,
          headers: { Accept: 'text/html' }
        })
          .then(function (res) {
            /* captcha challenge, redirect to another domain, or any non-OK answer -> use the normal submit */
            if (!res.ok || (res.url && res.url.indexOf('/challenge') > -1)) {
              nativeSubmit();
              return;
            }
            form.reset();
            dialog.querySelector('.morivia-review-dialog__form-wrap').hidden = true;
            dialog.querySelector('.morivia-review-dialog__success').hidden = false;
            if (btn) btn.disabled = false;
          })
          .catch(nativeSubmit);
      });

      /* after a normal (non-AJAX) submit the page reloads: reopen the popup with the result */
      function autoOpen() {
        var flag = document.querySelector('[data-morivia-review-autoopen]');
        if (!flag) return;
        var dialog = flag.closest('dialog');
        if (!dialog) return;
        openDialog(dialog);
        if (flag.getAttribute('data-morivia-review-autoopen') === 'success') {
          dialog.querySelector('.morivia-review-dialog__form-wrap').hidden = true;
          dialog.querySelector('.morivia-review-dialog__success').hidden = false;
          try {
            var url = new URL(window.location.href);
            url.searchParams.delete('contact_posted');
            window.history.replaceState({}, '', url.pathname + url.search + url.hash);
          } catch (e) {}
        }
      }
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', autoOpen);
      } else {
        autoOpen();
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["morivia-protocol"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('morivia-protocol')) {
    const normalize = (value) =>
      (value || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    const pad = (number) => String(number).padStart(2, '0');

    customElements.define(
      'morivia-protocol',
      class extends HTMLElement {
        get layout() {
          return this.media.matches ? this.dataset.mobile : this.dataset.desktop;
        }

        connectedCallback() {
          this.media = this.media || window.matchMedia('(max-width: 749px)');
          this.onResize = this.onResize || (() => this.queueProgress());
          window.addEventListener('resize', this.onResize);

          if (this.bound) return;
          this.bound = true;

          this.active = this.dataset.default || '';
          this.pageSize = parseInt(this.dataset.pageSize, 10) || 4;
          this.shown = this.pageSize;

          this.addEventListener('click', (event) => {
            const tab = event.target.closest('[data-tab]');
            if (tab) return this.select(tab.dataset.tab);
            if (event.target.closest('[data-search-toggle]')) return this.toggleSearch();
            if (event.target.closest('[data-search-close]')) return this.toggleSearch(false);
            if (event.target.closest('[data-more]')) {
              this.shown += this.pageSize;
              this.update();
            }
          });

          this.addEventListener('input', (event) => {
            if (event.target.matches('[data-search-input]')) {
              this.shown = this.pageSize;
              this.update();
            }
          });

          this.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && event.target.matches('[data-search-input]')) {
              this.toggleSearch(false);
              this.querySelector('[data-search-toggle]').focus();
            }
          });

          this.media.addEventListener('change', () => {
            this.shown = this.pageSize;
            this.update();
          });

          this.querySelector('.morivia-protocol__cards').addEventListener(
            'scroll',
            () => this.queueProgress(),
            { passive: true }
          );

          if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.update(), { once: true });
          } else {
            this.update();
          }
        }

        disconnectedCallback() {
          window.removeEventListener('resize', this.onResize);
        }

        select(id) {
          this.active = id;
          this.shown = this.pageSize;
          const input = this.querySelector('[data-search-input]');
          if (input) input.value = '';
          this.update();
          this.querySelector('.morivia-protocol__cards').scrollLeft = 0;
        }

        toggleSearch(force) {
          const box = this.querySelector('.morivia-protocol__search');
          const toggle = this.querySelector('[data-search-toggle]');
          const input = this.querySelector('[data-search-input]');
          const open = typeof force === 'boolean' ? force : box.hidden;

          box.hidden = !open;
          toggle.setAttribute('aria-expanded', String(open));
          this.shown = this.pageSize;

          if (open) {
            input.focus();
          } else {
            input.value = '';
          }
          this.update();
        }

        queueProgress() {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            if (this.layout !== 'grid') this.updateProgress();
          });
        }

        updateProgress() {
          const cards = this.querySelector('.morivia-protocol__cards');
          const bar = this.querySelector('[data-progress-bar]');
          const visible = [...cards.querySelectorAll('[data-card]')].filter((card) => !card.hidden);
          const total = visible.length;

          let ratio = 1;
          let current = total;

          if (total && cards.scrollWidth > cards.clientWidth + 1) {
            const viewRight = cards.scrollLeft + cards.clientWidth;
            ratio = Math.min(1, viewRight / cards.scrollWidth);
            current = visible.filter((card) => card.offsetLeft < viewRight - 4).length;
            if (cards.scrollWidth - viewRight < 4) current = total;
            current = Math.max(1, current);
          }

          if (bar) bar.style.width = `${ratio * 100}%`;
          this.setCounter(total ? current : 0, total);
        }

        setCounter(current, total) {
          const currentEl = this.querySelector('[data-current]');
          const totalEl = this.querySelector('[data-total]');
          if (currentEl) currentEl.textContent = pad(current);
          if (totalEl) totalEl.textContent = pad(total);
        }

        update() {
          const input = this.querySelector('[data-search-input]');
          const query = normalize(input ? input.value.trim() : '');
          const searching = query.length > 0;
          const grid = this.layout === 'grid';
          const seen = new Set();
          const matched = [];

          this.classList.toggle('is-searching', searching);

          this.querySelectorAll('[data-tab]').forEach((tab) => {
            tab.setAttribute('aria-selected', String(tab.dataset.tab === this.active));
          });

          this.querySelectorAll('[data-panel]').forEach((panel) => {
            panel.hidden = !searching && panel.dataset.panel !== this.active;
          });

          this.querySelectorAll('[data-card]').forEach((card) => {
            let show;

            if (searching) {
              const handle = card.dataset.handle;
              show = normalize(card.dataset.search).includes(query) && !(handle && seen.has(handle));
              if (show && handle) seen.add(handle);
            } else {
              show = card.closest('[data-panel]').dataset.panel === this.active;
            }

            card.hidden = true;
            if (show) matched.push(card);
          });

          // Grid view shows a limited number, slider view shows everything
          const limit = grid ? this.shown : Infinity;
          matched.forEach((card, index) => {
            card.hidden = index >= limit;
          });

          const visibleCount = Math.min(matched.length, limit);
          const empty = this.querySelector('[data-empty]');
          const moreWrap = this.querySelector('[data-more-wrap]');

          if (empty) empty.hidden = matched.length > 0;
          if (moreWrap) moreWrap.hidden = !(grid && matched.length > visibleCount);

          if (grid) {
            this.setCounter(visibleCount, matched.length);
          } else {
            this.updateProgress();
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
